// card-filter.ts — generic client-side "filter these cards by typed text" for STATIC, server-rendered
// card grids that are NOT JSON catalog mounts (e.g. the account hub, account.php). Unlike the
// data-ft-catalog-list flow there's no fetch and no endpoint: it simply shows/hides elements whose
// data-ft-card-filter-name contains the query. Vanilla DOM only, no jQuery.
//
// Contract (page-side):
//   <input data-ft-card-filter type="search" …>                         ← the search box
//   <a data-ft-card-filter-item data-ft-card-filter-name="my characters">…</a>  ← each filterable card
// Optional on the input:
//   data-ft-card-filter-scope="#sel"  ← restrict the item search to that subtree (default: document)
//
// Idempotent: each input is wired exactly once (marked data-ft-card-filter-wired), so re-scans of
// AJAX-injected markup are safe no-ops on already-wired inputs.

function wireCardFilter(input: HTMLInputElement): void {
    if (input.getAttribute('data-ft-card-filter-wired') === '1') return;
    input.setAttribute('data-ft-card-filter-wired', '1');

    const scopeSel = input.getAttribute('data-ft-card-filter-scope');
    const scope: ParentNode = (scopeSel && document.querySelector(scopeSel)) || document;
    const items = Array.from(scope.querySelectorAll<HTMLElement>('[data-ft-card-filter-item]'));

    const apply = (): void => {
        const q = input.value.trim().toLowerCase();
        for (const item of items) {
            const name = (item.getAttribute('data-ft-card-filter-name') || '').toLowerCase();
            item.style.display = !q || name.indexOf(q) !== -1 ? '' : 'none';
        }
    };

    input.addEventListener('input', apply);
    input.addEventListener('search', apply); // native clear (×) on type="search"
}

// Scan `root` (default document) for un-wired static card-filter inputs and wire each.
export function scanCardFilters(root?: ParentNode): void {
    (root || document)
        .querySelectorAll<HTMLInputElement>('input[data-ft-card-filter]:not([data-ft-card-filter-wired="1"])')
        .forEach(wireCardFilter);
}
